<template>
  <div class="container login-form">
    <div v-if="!isAuthenticated">
      <br>
      <form>
        <div class="form-group">
          <div class="input-group mb-3" style="width: 140px">
            <select v-model="countryID"
                    class="form-control"
                    aria-label="Страна"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.$store.getters.countries" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="float-left">Телефон</label>
          <input v-model="phone" class="form-control" placeholder="792759875145">
        </div>
        <div class="form-group">
          <label class="float-left">Пароль</label>
          <input v-model="password" type="password" class="form-control" placeholder="Password">
        </div>
        <button @click.prevent="login" type="submit" class="btn btn-primary">Войти</button>
      </form>
      <br>
      <p v-if="message" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
        <strong>{{ message }}</strong>
      </p>
    </div>
    <div v-else>
      Welcome!
      <br>
      <br>
      <router-link to="/invoices">
        <div class="btn btn-outline-primary my-2 my-sm-0">Счета и акты</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      password: '',
      message: '',
      countryID: 'ru',
    }
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  },

  methods: {
    login() {

      this.phone = this.phone.replace(/\D/g, '');
      if (this.phone.substr(0, 1) === '8') {
        this.phone = '7' + this.phone.substr(1)
      }

      this.$store.dispatch('login', {
        countryID: this.countryID,
        phone: this.phone,
        password: this.password
      })
          // .then(res => {
          //     // console.log(res)
          // })
          .catch(error => {
            // console.error(error);
            this.message = error;
            console.error(error);
            // console.error(error.message);
          })

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.container.login-form {
  max-width: 300px;
}
</style>
